// Cart jinis potro akhan theke suru*************
function showLoader(target) {
  const elements = document.querySelectorAll(target);
  elements.forEach(el => {
    if (el.classList.contains('loading-active')) return;
    const parent = el.parentElement;
    if (!parent) return;
    
    el.classList.add('loading-active');
  
    const loader = document.createElement('div');
    loader.className = 'rb-loader';
    loader.dataset.originalElement = true;
    
    el.style.display = 'none'
    parent.insertBefore(loader, el);
  });
}

function hideLoader(target) {
  const elements = document.querySelectorAll(target);
  elements.forEach(el => {
    el.classList.remove('loading-active');
    el.style.display = '';

    const parent = el.parentElement;
    if (parent) {
      const loaders = parent.querySelectorAll('.rb-loader');
      loaders.forEach(loader => loader.remove());
    }
  });
}

function scrollToElement(element, offset){
   const offsetTop = $(element).offset().top;
  $([document.documentElement, document.body]).animate({
    scrollTop: offsetTop - offset
  }, 300);
}

function getUniqueElements(elements){
  return Array.from(elements).filter(el => el.offsetParent != null );
}

async function updateCartQuantity (key, quantity){
  try {
    const response = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type" : "application/json"},
      body : JSON.stringify({ updates : { [key] : quantity }})
    });
    const cart = await response.json();
    return cart;
  } catch (error) {
    console.log("Error From Update cart QTY", error)
  }
}

async function handleQuantityChange(input){
  try {
    showLoader('.cart-total-price .money');
    showLoader('.mobile-sticky-checkout button .money');
    $(".cart-item-quantity-box button").attr("disabled", true);
    const cartItemKey = input.currentTarget.id;
    const newQuantity = input.currentTarget.valueAsNumber;

    const cart = await updateCartQuantity(cartItemKey, newQuantity);
    updateUI(cart);

    if(newQuantity === 0 ){
      removeCartElement(cartItemKey);
      checkExistingCartItems();
      datepickerModule.refreshTagLogic();
    }

    checkIfCartEmpty();
    
    $(".cart-item-quantity-box button").attr("disabled", false);
    
  } catch (error) {
    console.log("Error From handleQuantityChange", error)
  } finally {
    hideLoader('.cart-total-price .money');
    hideLoader('.mobile-sticky-checkout button .money');
  }
 
}


function checkIfCartEmpty() {
  const remainingItems = document.querySelectorAll('.cart-item-js');
  if (remainingItems.length === 0) {
    location.reload();
  }
}


function removeCartElement(key){
  
  const allCartItems = document.querySelectorAll('.cart-item-js');
  const getNoSaturdayProducts = document.querySelectorAll(".no-saturday");
  const getNoSundayProducts = document.querySelectorAll(".no-sunday");
  const getAllExpressProducts = document.querySelectorAll(".express-product");

  const cartItem = document.querySelector(`.cart-item-js[data-key="${key}"]`);
  if (cartItem) cartItem.remove();

  if(getNoSaturdayProducts.length === 0){
    PRODUCTCONFIG.noSaturday = false;
  }
  
  if(getNoSundayProducts.length === 0){
    PRODUCTCONFIG.noSunday = false;
  }

  if(getAllExpressProducts.length === 0){
    PRODUCTCONFIG.isExpress = false;
  }
  
}

function updateUI (cart) {
  const priceElements = ['.cart-total-price .money', '.mobile-sticky-checkout button .money'];
  priceElements.forEach(elm => {
    const targetElm = document.querySelector(elm);
    if(targetElm) targetElm.textContent = Shopify.formatMoney(cart.total_price, $('body').data('money-format'));
  });

 const cartItemCounts = document.querySelectorAll(".cart_count");
  cartItemCounts.forEach((el) => {
      el.innerHTML = cart.item_count;
  });

}

function bindEvents(){
  $(".cart-item-quantity-box .quantity").on("change", handleQuantityChange);
  
  $("button#delete-item-button").on("click", function(e) {
    e.preventDefault();
    const itemKey = $(this).data("key");
    const $input = $(`.cart-item-quantity-box input[data-key="${itemKey}"]`);
    $input.val(0).trigger("change");
  });
}

document.addEventListener("DOMContentLoaded", () => {
  bindEvents();
  initializeAddons();
  checkExistingCartItems();
});


// Addons Functionality suru*****************
const selections = {
  single: null,
  multi: new Set()
};

const allGreetingCards = document.querySelectorAll("[data-greeting-addons] .splide__slide");
const allCartAddons = document.querySelectorAll("[data-cart-addons] .splide__slide");

function initializeAddons(){
  
  allGreetingCards.forEach( card => {
    card.addEventListener("click", (event) => {
       handleAddonClicked(card, "single");
        if($("[data-greeting-addons]").hasClass("field-error")){
           $("[data-greeting-addons]").removeClass("field-error");
        }
    });
  });

  allCartAddons.forEach(addon => {
    addon.addEventListener("click", (event) => {
     handleAddonClicked(addon, "multi");
    });
  });

};


async function handleAddonClicked(addonElement, selectionType) {
 
  const variantId = addonElement.dataset.vid;
  const isSelected = addonElement.classList.contains("addons-selected");
  
  toggleBlurEffect(addonElement, true);

  if(isSelected) {
    
    const cart = await updateCartQuantity(variantId, 0);
    addonElement.classList.remove("addons-selected");
    updateAddonsInCart(cart);
    updateUI(cart);
    if(selectionType === "multi"){
      selections.multi.delete(variantId);
    } else {
      selections.single = null;
    }
    
  } else {
    
    if(selectionType === "single" && selections.single){
      selections.single.classList.remove("addons-selected");
      await updateCartQuantity(selections.single.dataset.vid, 0);
    }
    
    const cart = await updateCartQuantity(variantId, 1);
    addonElement.classList.add("addons-selected");
    updateAddonsInCart(cart);
    updateUI(cart);
    if(selectionType === "multi"){
      selections.multi.add(variantId);
    } else {
      selections.single = addonElement;
    }
  }

  toggleBlurEffect(addonElement, false);
  
};


function toggleBlurEffect(clickedElement, isApplying) {
  const slideList = clickedElement.closest(".splide__list");
  const slides = slideList.querySelectorAll(".splide__slide");
  slides.forEach(slide => {
     if (isApplying) {
       if (slide !== clickedElement) {
          slide.classList.add('addons-blur');
       }
       clickedElement.classList.add('addons-loading');
        showLoader('.cart-total-price .money');
        showLoader('.mobile-sticky-checkout button .money');
     } else {
        slide.classList.remove('addons-blur', 'addons-loading');
        hideLoader('.cart-total-price .money');
        hideLoader('.mobile-sticky-checkout button .money');
     }
  });
};

async function updateAddonsInCart(){
  try{
    const response = await fetch('?section_id=cart-template-v3');
    const html = await response.text();
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    const newContainer = tempDiv.querySelector(".cart-items-container");
    const currentContainer = document.querySelector(".cart-items-container");

    if (newContainer && currentContainer) {
      currentContainer.innerHTML = newContainer.innerHTML;
    } else {
      console.warn('Cart items container not found');
    }

  } catch( err ) {
    console.log("Error from updateAddonsInCart functions!")
  } finally {
    bindEvents();
  }
  
}


async function checkExistingCartItems(){
  const response = await fetch("/cart.js");
  const cart = await response.json();
  let foundInCart = false;
  let selectedIndex = 0;
  
  allGreetingCards.forEach( (card, index) => {
     const variantId = card.dataset.vid;
     const cartItem = cart.items.find(item => item.variant_id.toString() === variantId);
     if (cartItem && cartItem.quantity > 0) {
        card.classList.add('addons-selected');
        selections.single = card;
        foundInCart = true;
        selectedIndex = index;
     }else {
        card.classList.remove('addons-selected');
     }
  });

  allCartAddons.forEach( (addon, index) => {
     const variantId = addon.dataset.vid;
     const cartItem = cart.items.find(item => item.variant_id.toString() === variantId);
     if (cartItem && cartItem.quantity > 0) {
        addon.classList.add('addons-selected');
        selections.multi.add(variantId);
     }else {
        addon.classList.remove('addons-selected');
     }
  });

  if (window.splide) {
      window.splide.go(foundInCart ? selectedIndex : 0);
  }
}
// Addons Functionality ses*****************


// Validation akhan theke suru******************

function proceedCheckout(){
   $(".checkout_original").trigger("click");
}

function validatecardMessageField() {
  
  const cardMessageField = document.querySelector('.card-message-textarea');
  if(!cardMessageField.value){
      Swal.fire({
        html: `Do you want to proceed with an <b>Empty message card?</b>`,
        icon: "error",
        showConfirmButton: true,
        confirmButtonText: 'Continue',
        confirmButtonColor: '#55bc88',
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'Cancel',
        cancelButtonColor: '#DD6B55',
        backdrop: `rgba(0, 0, 0, 0.75)`
      }).then((result) => {
        if (result.isConfirmed) {
          proceedCheckout();
        } else if (result.isDismissed) {
          scrollToElement(cardMessageField, 250);
          $(cardMessageField).addClass("field-error");
        }
      });
  } else {
    cardMessageField.classList.remove("field-error");
     proceedCheckout();
  }
}

function validateCartProducts(){
  const allGreetingCards = document.querySelectorAll(".greeting-cards");
  if(allGreetingCards.length === 0) {
      Swal.fire({
        html: `You have not selected a <b>Greeting Card.</b> Do you want to proceed without a <b>Greeting Card?</b>`,
        icon: "error",
        showConfirmButton: true,
        confirmButtonText: 'Continue',
        confirmButtonColor: '#55bc88',
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'Cancel',
        cancelButtonColor: '#DD6B55',
        backdrop: `rgba(0, 0, 0, 0.75)`
      }).then((result) => {
        if (result.isConfirmed) {
          proceedCheckout();
        } else if (result.isDismissed) {
          scrollToElement("[data-greeting-addons]", 350);
          $("[data-greeting-addons]").addClass("field-error");
           $(cardMessageField).removeClass("field-error");
        }
      });
  } else {
    validatecardMessageField();
  }
}

$("#checkout_clone, .mobile-sticky-checkout button").on("click",function(){
  if (
    typeof window.customAbValidateTimeslot === "function" &&
    !window.customAbValidateTimeslot()
  ) {
    window.customAbRefreshTimeslots();
    Swal.fire({
      html: "The delivery time slot you selected is no longer available.<br>Please select the next available delivery slot to continue with your order.",
      icon: "error",
      confirmButtonText: "OK",
    }).then(function () {
      scrollToElement("#timeslot-container-js", 250);
    });
    return;
  }
  validateCartProducts();
});

// Validation akhan theke ses******************